/* eslint-disable id-length,max-params */
export var polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
};
export var describeArc = function (type, x, y, radius, startAngle, endAngle) {
    var start = polarToCartesian(x, y, radius, endAngle);
    var end = polarToCartesian(x, y, radius, startAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    var startCoords = start.x + "," + start.y;
    var endCoords = end.x + "," + end.y;
    return "" + type + (type === 'M' ? endCoords : startCoords) + " A" + radius + "," + radius + ",0," + largeArcFlag + "," + (type === 'M' ? 1 : 0) + "," + (type === 'M' ? startCoords : endCoords);
};
export var getGradientCoords = function (x, y, radius, circleWidth, startAngle, endAngle) {
    return {
        start: polarToCartesian(x, y, radius, startAngle),
        end: polarToCartesian(x, y, radius - circleWidth / 2, endAngle)
    };
};
//# sourceMappingURL=svg.js.map